"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildAreaBreakdown = buildAreaBreakdown;
exports.buildStatTiles = buildStatTiles;
exports.buildStatusBreakdown = buildStatusBreakdown;
exports.buildTasksOverTime = buildTasksOverTime;
var chart_colors_1 = require("../constants/chart-colors");
function buildStatTiles(summary) {
    var _a = summary.counts, total = _a.total, completed = _a.completed, open = _a.open, overdue = _a.overdue;
    var percent = function (count) { return (total > 0 ? Math.round((count / total) * 100) : 0); };
    return [
        { label: "Total Tasks", value: String(total), icon: "solar:checklist-linear", tone: "primary" },
        {
            label: "Completed",
            value: String(completed),
            icon: "solar:check-circle-linear",
            tone: "success",
            helperText: "".concat(percent(completed), "%"),
            progressPercent: percent(completed),
        },
        {
            label: "Open",
            value: String(open),
            icon: "solar:hourglass-linear",
            tone: "warning",
            helperText: "".concat(percent(open), "%"),
            progressPercent: percent(open),
        },
        {
            label: "Overdue",
            value: String(overdue),
            icon: "solar:danger-triangle-linear",
            tone: "critical",
            helperText: "".concat(percent(overdue), "%"),
            progressPercent: percent(overdue),
        },
    ];
}
function buildStatusBreakdown(summary) {
    var _a = summary.counts, completed = _a.completed, open = _a.open, overdue = _a.overdue;
    return [
        { name: "Completed", value: completed, color: chart_colors_1.CHART_COLORS.good },
        { name: "Open", value: open, color: chart_colors_1.CHART_COLORS.warning },
        { name: "Overdue", value: overdue, color: chart_colors_1.CHART_COLORS.critical },
    ];
}
function buildAreaBreakdown(summary) {
    var AREA_COLOR_PALETTE = [chart_colors_1.CHART_COLORS.blue, chart_colors_1.CHART_COLORS.green, chart_colors_1.CHART_COLORS.magenta, chart_colors_1.CHART_COLORS.yellow, chart_colors_1.CHART_COLORS.aqua, chart_colors_1.CHART_COLORS.orange];
    return summary.areaBreakdown.map(function (entry, index) { return ({
        name: entry.area.name,
        value: entry.count,
        color: AREA_COLOR_PALETTE[index % AREA_COLOR_PALETTE.length],
    }); });
}
function buildTasksOverTime(summary) {
    return summary.timeline.map(function (point) { return ({
        date: new Date(point.timestamp).toLocaleDateString("en-US", { month: "short", day: "numeric" }),
        completed: point.completed,
        inProgress: point.open,
        overdue: point.overdue,
    }); });
}
